// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ricarica/colonnine?societaId',
    requestBody: null,
    response: '{success:true,data:{gateway:{raggiungibile,ultimoContattoAt},colonnine:[{id,societaId,societaNome,nome,codiceOcpp,sede,marca,modello,seriale,firmware,collegata,ultimoContattoAt,stato,codiceErrore,attiva,passwordImpostata,connettori}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/sedi?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/colonnine',
    requestBody: '{societaId,nome,codiceOcpp,sedeId}',
    response: '{success:true,data:{id}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
